module.exports = __webpack_public_path__ + "img/da60c79.jpg";